import { GroupEmail, IGroupEmail, IUnitOfMeasure } from "./AdminInterface";
import { IDispatchConfirm, IDispatchTicketList, IDispatchTruck } from "./DispatchInterface";
import { IEBPExpenseType, IProduct, IRemarks } from "./TestInterface";

class IContact {
    public id: string = "";
    public contactTypeName: string = '';
    public email: string = '';
    public groupEmail: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public location: string = '';
    public onJob: boolean = true;
    public otherTypeName: string = '';
    public phoneNumber: string = '';
    public phoneMobile: string = '';
    public phoneAlternate: string = '';
}

// class IEffectiveDates {
//    public effectiveDate: string = '';
// }

class IOperator {
    public id: string = '';
    public operatorName: string = '';
    public groupEmail: string = '';
    public contacts: IContact[] = [];
    public regions: IRegion[] = [];
    public erpId: string = '';
    public groupEmails: IGroupEmail[] = [];
    public effectiveDate: string = '';
    public billingAddress: string = '';
    public billingCityStateZip: string = '';
}

class IContractor {
    public id: string = "";
    public contractorName: string = '';
    public groupEmail: string = '';
    public contacts: IContact[] = [];
    public groupEmails: IGroupEmail[] = [];
}

class IWarehouse {
    public id: string = "";
    public name: string = '';
    public phone: string | number = '';
}

class IEngineer extends IContact {
    public isSupervisor: boolean = false;
    public roles: string[] = [];
    public active: boolean = true;
}

class IAttachedFile {
    public id: string;
    public name: string;
    public fileType: string;
    public createDate: string;
    public updateDate: string;
    public createUserId: string;
    public updateUserId: string;
    public size: string;
    public createUser: string;
    public fileCategory: string;
}

class ICheckDate {
   public operatorId: string = '';
   public regionId: string = '';
   public startDate: string = '';
}

class IWell {
    public afeNumber: string = '';
    public apiNumber: string = '';
    public bhlAbstract: string = '';
    public bhlBlock: string = '';
    public bhlBlockDirection: string = '';
    public bhlFromPointEW: string = '';
    public bhlFromPointEWDistance: string = '';
    public bhlFromPointNS: string = '';
    public bhlFromPointNSDistance: string = '';
    public bhlgpsLatitude: string = '';
    public bhlgpsLongitude: string = '';
    public bhlLeague: string = '';
    public bhlisLabour: boolean = false;
    public bhlLabour: string = '';
    public bhlRange: string = '';
    public bhlRangeDirection: string = '';
    public bhlSection: string = '';
    public bhlSurvey: string = '';
    public bhlTownship: string = '';
    public bhlTownshipDirection: string = '';
    public contacts: IContact[] = [];
    public contractor: IContractor = new IContractor();
    public contractorName: string = '';
    public contractorContacts: IContact[] = [];
    public countyParish: string = '';
  //  public effectiveDates: IEffectiveDates[] = [];
    public engineers: IEngineer[] = [];
    public engineerIds?: string[];
    public erpId: string = '';
    public directions: string = '';
    public dispatchTickets: IDispatchTicketList[] =[];
    public fieldAreaUnit: string = '';
    public files: IAttachedFile[] = [];
    public finishDate: string = '';
    public groupEmail: string = '';
    public id: string = "";
    public internalEmails: GroupEmail[] = [];
    public legalDescription: string = '';
    public operator: IOperator = new IOperator();
    public operatorName: string = '';
    public region: IRegion = new IRegion();
    public UnitOfMeasure: IUnitOfMeasure = new IUnitOfMeasure();
    public operatorContacts: IContact[] = [];
    public otherContacts: IContact[] = [];
    public productTaxRate: number = '' as unknown as number;
    public projectedCost: number | string = '';
    public projectedDepth: number | string = '';
    public projectedKOP: number | string = '';
    public projectedEOC: number | string = '';
    public rentalTaxRate: number = '' as unknown as number;
    public rigNumber: string ="";
    public serviceTaxRate: number = '' as unknown as number;
    public shlAbstract: string = '';
    public shlBlock: string = '';
    public shlBlockDirection: string = '';
    public shlFromPointEW: string = '';
    public shlFromPointEWDistance: string = '';
    public shlFromPointNS: string = '';
    public shlFromPointNSDistance: string = '';
    public shlgpsLatitude: string = '';
    public shlgpsLongitude: string = '';
    public shlisLabour: boolean = false;
    public shlLabour: string = '';
    public shlLeague: string = '';
    public shlRange: string = '';
    public shlRangeDirection: string = '';
    public shlSection: string = '';
    public shlSurvey: string = '';
    public shlTownship: string = '';
    public shlTownshipDirection: string = '';
    public sidetrack: string = '';
    public spudDate: string = '';
    public startDate: string = '';
    public effectiveDate: string = '';
    public state: string = '';
    public targetFormation: string = '';
    public tenantId: string = '';
    public timeZoneName: string = '';
    public wellBoreNumberId: string = '';
    public wellName: string = '';
    public wellSetupComplete: boolean = false;
    public wellStatus: string = 'Active';
    public wellType: string = '';
    public warehouseId: string = '';
    public warehouseName: string = '';
    public warehousePhone: string = '';
    public latestTestId?: string = '';
    public latestTestDate?: string = '';
    public deliveriesPending: IDispatchConfirm[] = [];
    public pickupsPending: IDispatchConfirm[] = [];
    public invoiceReady: string = '';
}

interface IWellCloseReview {
    id: string;
    wellId: string;
    productTotal: number;
    productTax: number;
    otherCosts: number;
    otherCostTax: number;
    wellTotal: number;
    productTaxRate: number;
    serviceTaxRate: number;
    rentalTaxRate: number;
    adjustedProductTotal: number;
    adjustedProductTax: number;
    adjustedOtherCosts: number;
    adjustedOtherCostTax: number;
    adjustedWellTotal: number;
    totalDifferencePercent: number;
    totalDifferenceCost: number;
    invoiceReady: boolean;
    products: IWellCloseReviewProduct[];
    expenses: IWellCloseReviewExpense[];
    intervalCosts: IWellIntervalCost[];
    remarks: IWellCloseTestRemark[];
    volumeAccounting: IWellCloseVolumeAccounting;
    pickupsPending: IDispatchConfirm[];
    dispatchTrucksReturned: IDispatchTruck[];
}

interface IIntervalNameChange{
    wellCloseReviewId: string;
    index: number;
    intervalType: string;
    oldIntervalType: string;
    subInt: string;
    oldSubInt: string;
}

interface IWellCloseReviewExpense {
    id: string;
    wellCloseReviewId: string;
    expenseTypeId: string;
    expenseType: IEBPExpenseType;
    referenceNumber: string;
    totalUnits: number;
    unitPrice: number;
    totalPrice: number;
    adjustments: number;
    differencePrice: number;
    finalUnits: number;
    finalPrice: number;
    isTaxable: boolean;
    isDelible: boolean;
}

interface IWellCloseVolumeAccounting {
    id: string;
    startingBaseOil: number;
    baseOilReceived: number;
    baseOilUsed: number;
    endingBaseOil: number;
    cumBaseOilUsed: number;
    prevCumBaseOilUsed: number;
    baseOil: number;
    water: number;
    chemicalAdditions: number;
    slurry: number;
    waterFlow: number;
    otherAdditions: number;
    totalAdditions: number;
    lossToFormation: number;
    lossToSurface: number;
    solidsControl: number;
    mudLeftInHole: number;
    otherLoss: number;
    totalLosses: number;
    finalTestVolume: number;
    totalVolAdditions: number;
    totalVolLosses: number;
    otherVolTransferred: number;
    plantVolReturned: number;
    reconciliationFactor: number;
    volOwedToPlant: number;
    prevVolOwedToPlant: number;
}

class WellCloseReviewExpense implements IWellCloseReviewExpense{
    public id = '';
    public wellCloseReviewId = '';
    public expenseTypeId = '';
    public expenseType = new IEBPExpenseType();
    public referenceNumber = '';
    public totalUnits = 0;
    public unitPrice = 0;
    public totalPrice = 0;
    public adjustments = 0;
    public differencePrice = 0;
    public finalUnits = 0;
    public finalPrice = 0;
    public isTaxable = true;
    public isDelible = true;
}

interface IWellCloseReviewProduct {
    id: string;
    wellCloseReviewId: string;
    productId: string;
    product: IProduct;
    price: number;
    totalReceived: number;
    totalReturned: number;
    returnedOverage: number;
    totalAdjusted: number;
    totalUsed: number;
    closingAmount: number;
    credited: number;
    difference: number;
    totalCost: number;
    isTaxable: boolean;
    isDelible: boolean;
}

class WellCloseReviewProduct implements IWellCloseReviewProduct {
    public id = '';
    public wellCloseReviewId = '';
    public productId = '';
    public product = new IProduct();
    public price = 0;
    public totalReceived = 0;
    public totalReturned = 0;
    public returnedOverage = 0;
    public totalAdjusted = 0;
    public totalUsed = 0;
    public closingAmount = 0;
    public credited = 0;
    public difference = 0;
    public totalCost = 0;
    public isTaxable = true;
    public isDelible = true;
}

interface IWellCloseTestRemark {
    id: string;
    testDate: number;
    depthMD: number;
    depthTVD: number;
    depthBit: number;
    presentActivity: string;
    isNewIntervalReport: boolean;
    kopMD: number;
    kopTVD: number;
    eocMD: number;
    eocTVD: number;
    fluidSubType: string;
    dailyCost: number;
    cumulativeCost: number;
    remarks: IRemarks;
}

interface IWellIntervalCost {
    id: string;
    intervalType: string;
    oldIntervalType: string;
    oldSubInt: string;
    subInt: string;
    fluidType: string;
    products: IWellIntervalCostProduct[];
    expenses: IWellIntervalCostExpense[];
}

interface IWellIntervalCostProduct {
    id: string;
    product: IProduct;
    price: number;
    quantity: number;
}

class WellIntervalCostProduct {
    public id: '';
    public product: undefined;
    public price: 0;
    public quantity: 0;
}

class WellIntervalCostExpense {
    public id: '';
    public expense: undefined;
    public price: 0;
    public quantity: 0;
}

interface IWellIntervalCostExpense {
    id: string;
    expense: IEBPExpenseType;
    price: number;
    quantity: number;
}

class IRegion {
    public id: string = '';
    public name: string = '';
    public state: string = '';
    public effectiveDate: string = '';
    public operators: IOperator[] = [];
}


export { IContractor, ICheckDate, IEngineer, IContact, IOperator, IRegion, IWarehouse, IWell, IWellCloseReview, IWellCloseReviewExpense, IWellCloseReviewProduct, IWellCloseTestRemark, WellCloseReviewExpense, WellCloseReviewProduct, IWellIntervalCost, IWellIntervalCostExpense, IWellIntervalCostProduct, WellIntervalCostExpense, WellIntervalCostProduct, IAttachedFile, IIntervalNameChange };




// WEBPACK FOOTER //
// ./src/Interfaces/WellInterface.tsx